import { render, staticRenderFns } from "./tallyClerk.vue?vue&type=template&id=d2b33fcc"
import script from "./tallyClerk.vue?vue&type=script&lang=js"
export * from "./tallyClerk.vue?vue&type=script&lang=js"
import style0 from "./tallyClerk.vue?vue&type=style&index=0&id=d2b33fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports